/* ====================================================================================================================
 * FAYARD CUSTOM — JavaScript personnalisé Maison Fayard
 * --------------------------------------------------------------------------------------------------------------------
 * Regroupe les comportements JS personnalisés isolés du code natif Prestige, pour faciliter les futures mises à jour.
 * Chargé depuis layout/theme.liquid.
 * ==================================================================================================================== */

/* --------------------------------------------------------------------------------------------------------------------
 * Fix affichage du symbole € : colle le symbole après le montant (ex: "€12,50" -> "12,50€")
 * Externalisé depuis layout/theme.liquid.
 * ------------------------------------------------------------------------------------------------------------------ */
(function () {
  function fixEuro(root) {
    root = root || document;
    var nodes = root.querySelectorAll(
      '.price, .price-item, .price-list, [class*="price"], .money, [data-product-price], [data-cart-item-regular-price]'
    );

    nodes.forEach(function (el) {
      if (el.dataset.euroFixed === '1') return;
      var originalHTML = el.innerHTML;

      // Remplace pour coller le symbole €
      var newHTML = originalHTML.replace(/€\s*([0-9]{1,3}(?:[.,][0-9]{3})*(?:[.,][0-9]{2})?)/g, '$1€');

      if (newHTML !== originalHTML) {
        el.innerHTML = newHTML;
        el.dataset.euroFixed = '1';
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () { fixEuro(); });

  new MutationObserver(function () { fixEuro(); }).observe(document.documentElement, {
    childList: true, subtree: true, characterData: true
  });
})();
